<div class="row">
  <div class="col-12">
    <div class="filter-body">
      <div class="filter">
        <div class="row">
          <div class="col-11">
            <div class="row" [formGroup]="prescriptionFilterForm" *ngIf="!showAdvancedFilter">
              <div class="col">
                <input type="text" class="form-control " id="reqSender" placeholder="Request ID"
                  formControlName="requestId" appPreventFirstSpace>
              </div>
              <div class="col">
                <input type="text" class="form-control " id="preSender" placeholder="Prescription ID"
                  formControlName="senderId" appPreventFirstSpace>
              </div>
              <div class="col" *ngIf="( subTypeEvm === subTypes.provider|| subTypeEvm === subTypes.both)">
                  <input type="text" class="form-control " id="prePayer" placeholder="Provider ID"
                  formControlName="providerId" appPreventFirstSpace>
              </div>
              <div class="col" *ngIf="( subTypeEvm === subTypes.payer|| subTypeEvm === subTypes.both)">
                <input type="text" class="form-control " id="prePayer" placeholder="Payer ID"
                  formControlName="payerId" appPreventFirstSpace>
              </div>
              <div class="col">
                <input type="text" class="form-control " id="preMember" placeholder="Member ID"
                  formControlName="memberId" appPreventFirstSpace>
              </div>
              <div class="col">
                <input type="text" class="form-control " id="preFacility" placeholder="Facility ID"
                  formControlName="documentID" appPreventFirstSpace>
              </div>
              <div class="col-2">
                <app-single-select [isListing]="true" uid="id" [searchShow]=false [dataArr]="ifAuthcheck()"
                  (selectedEvent)="selectedValue($event,'status');" label="name"
                  [selectedData]="prescriptionFilterForm.value.status" [placeholder]="'Status'">
                </app-single-select>

              </div>
              <div class="col">
                <input autocomplete="disabled" class="form-check-input" formControlName="isOverriden"
                  type="checkbox" id="isOverriden" name="isOverriden">
                <label class="form-check-label link" for="inUse">Is Overriden</label>
              </div>
              <div class="col-2 d-flex">
                <button id="btnGroupApply" type="button" class="btn btn-dark-blue" (click)="page_no=1;userTypeListing()"
                  [ngClass]="{'disabled':prescriptionFilterForm.invalid}">APPLY</button>
                <a class="reset-btn" (click)="resetFilter();advFilter=false;"><span></span>Reset</a>
              </div>
            </div>

          </div>
          <div class="col-1">
            <a class="advanced-btn float-end" id="advanced-search"
              (click)="onAdvancedClick($event)">Advanced</a>
          </div>
          <!-- Advanced filter items -->
          <div class="col-12" #advancedFilter>
            <div *ngIf="showAdvancedFilter" class="dropdown post-code-dropdown advanced-search">


              <div class="dropdown-menu show" aria-labelledby="post-code"
                (click)="onInsideAdvanceContainerClick()">

                <div class="dropdown-body">
                  <div class="row" [formGroup]="prescriptionFilterForm">
                    <div class="col-2 mb-3">
                      <label class="form-label" for="reqIDAdv">Request ID</label>
                      <input type="text" class="form-control " id="reqIDAdv" placeholder=""
                        formControlName="requestId" appPreventFirstSpace>
                    </div>
                    <div class="col-2 mb-2">
                      <label class="form-label" for="prescriptionIDAdv">Prescription ID</label>
                      <input type="text" class="form-control " id="prescriptionIDAdv" placeholder=""
                        formControlName="prescriptionId" appPreventFirstSpace>
                    </div>
                    <!-- <div class="col-2 mb-3">
                      <label class="form-label" for="PayerIDAdv">Payer ID</label>
                      <input type="text" class="form-control " id="PayerIDAdv" placeholder=""
                        formControlName="payerId" appPreventFirstSpace>
                    </div> -->
                    <div class="col-2 mb-3">
                      <label class="form-label" for="encounterType">Member ID</label>
                      <input type="text" class="form-control " id="MemberADv" placeholder=""
                        formControlName="memberId" appPreventFirstSpace>
                    </div>
                    <div class="col-2 mb-2">
                      <label class="form-label" for="FacilityAdv">Facility ID</label>
                      <input type="text" class="form-control " id="FacilityAdv" placeholder=""
                        formControlName="documentID" appPreventFirstSpace>
                    </div>
                    <div class="col-2 mb-2">
                      <label class="form-label" for="StatusPreAdv">Status</label>
                      <app-single-select [isListing]="true" uid="id" [searchShow]=false
                        [dataArr]="ifAuthcheck()" (selectedEvent)="selectedValue($event,'status');" label="name"
                        [selectedData]="prescriptionFilterForm.value.status" [placeholder]="'Select'">
                      </app-single-select>
                    </div>
                    <div class="col-2 mb-3">
                      <label class="form-label" for="preSenderAdv">Sender ID</label>
                      <input type="text" class="form-control " id="preSenderAdv" placeholder=""
                        formControlName="senderId" appPreventFirstSpace>
                    </div>
                    <div class="col-2 mb-3">
                      <label class="form-label" for="preReceiverAdv">Receiver ID</label>
                      <input type="text" class="form-control " id="preReceiverAdv" placeholder=""
                        formControlName="receiverId" appPreventFirstSpace>
                    </div>
                    <div class="col-2 mb-3" *ngIf="( subTypeEvm === subTypes.payer|| subTypeEvm === subTypes.both)">
                      <label class="form-label" for="PayerIDAdv">Payer ID</label>
                      <input type="text" class="form-control " id="PayerIDAdv" placeholder="" formControlName="payerId"
                        appPreventFirstSpace>
                    </div>
                    <div class="col-2 mb-2" *ngIf="( subTypeEvm === subTypes.provider|| subTypeEvm === subTypes.both)">
                      <label class="form-label" for="providerIDAdv">Provider ID</label>
                      <input type="text" class="form-control " id="providerIDAdv" placeholder=""
                        formControlName="providerId" appPreventFirstSpace>
                    </div>
                    <div class="col-2 mb-2">
                      <label class="form-label" for="EHealthIDAdv">EHealth ID</label>
                      <input type="text" class="form-control " id="EHealthIDAdv" placeholder=""
                        formControlName="healthId" appPreventFirstSpace>
                    </div>
                    
                    <div class="col-2 mt-4">
                      <input autocomplete="disabled" class="form-check-input" formControlName="isOverriden"
                        type="checkbox" id="isOverriden" name="isOverriden">
                      <label class="form-check-label link" for="inUse">Is Overriden</label>
                    </div>

                    <div class="col-12">
                      <hr>
                    </div>
                    <div class="col-12">
                      <div class="btn-wrap float-end">

                        <button type="button" class="btn btn-outline-secondary" id="reset-filter-btn"
                          (click)="resetFilter();advFilter=false">RESET</button>
                        <button type="button" class="btn btn-primary disabled" id="apply-filter-btn"
                          (click)="page_no=1;userTypeListing();advFilter=true"
                          [ngClass]="{'disabled':prescriptionFilterForm.invalid}">APPLY</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-12">
    <div class="filter-wrap margin-minus" *ngIf="advFilter">
      <span class="filter-item" *ngIf="prescriptionFilterForm.value?.providerId && ( subTypeEvm === subTypes.provider|| subTypeEvm === subTypes.both)">
        Provider Id : {{prescriptionFilterForm.value.providerId}}
        <a (click)="closeAdvanceFilter('providerId')">
          <img src="assets/images/icons/filter-close.svg" alt="">
        </a>
      </span>
      <span class="filter-item" *ngIf="prescriptionFilterForm.value?.payerId && ( subTypeEvm === subTypes.payer|| subTypeEvm === subTypes.both)">
        Payer Id : {{prescriptionFilterForm.value.payerId}}
        <a (click)="closeAdvanceFilter('payerId')">
          <img src="assets/images/icons/filter-close.svg" alt="">
        </a>
      </span>
      <span class="filter-item" *ngIf="prescriptionFilterForm.value?.healthId">
        Health Id : {{prescriptionFilterForm.value?.healthId}}
        <a (click)="closeAdvanceFilter('healthId')">
          <img src="assets/images/icons/filter-close.svg" alt="">
        </a>
      </span>
      <span class="filter-item" *ngIf="prescriptionFilterForm.value?.receiverId">
        Receiver ID : {{prescriptionFilterForm.value?.receiverId}}
        <a (click)="closeAdvanceFilter('receiverId')">
          <img src="assets/images/icons/filter-close.svg" alt="">
        </a>
      </span>
      <span class="filter-item" *ngIf="prescriptionFilterForm.value?.senderId">
        Sender ID : {{prescriptionFilterForm.value?.senderId}}
        <a (click)="closeAdvanceFilter('senderId')">
          <img src="assets/images/icons/filter-close.svg" alt="">
        </a>
      </span>
    </div>
  </div>
  <div class="col-12">
    <div class="table-container table-responsive">

      <table class="table table-list">
        <caption class="d-none">Provider list table body</caption>

        <thead>
          <tr>
            <th scope="col">Request#
              <span *ngIf="transactionListByClient.length" class="sort-order"
                (click)="sortColumn('requestId')">
                <a class="{{columnSort['requestId'].sortType}} "></a>
              </span>
            </th>
            <th scope="col">Sender id <span *ngIf="transactionListByClient.length" class="sort-order"
                (click)="sortColumn('senderId')"><a class="{{columnSort['senderId'].sortType}} "></a></span>
            </th>
            <th scope="col">receiver id <span *ngIf="transactionListByClient.length" class="sort-order"
                (click)="sortColumn('receiverId')"><a
                  class="{{columnSort['receiverId'].sortType}} "></a></span>
            </th>
            <th scope="col">transcation date <span *ngIf="transactionListByClient.length" class="sort-order"
                (click)="sortColumn('transactionDate')"><a
                  class="{{columnSort['transactionDate'].sortType}} "></a></span>
            </th>
            <th scope="col" *ngIf="( subTypeEvm === subTypes.payer|| subTypeEvm === subTypes.both)">Payer id <span *ngIf="transactionListByClient.length" class="sort-order"
                (click)="sortColumn('payerId')"><a class="{{columnSort['payerId'].sortType}} "></a></span>
            </th>
            <th scope="col" *ngIf="( subTypeEvm === subTypes.provider|| subTypeEvm === subTypes.both)">Provider id <span *ngIf="transactionListByClient.length" class="sort-order"
                (click)="sortColumn('providerId')"><a class="{{columnSort['providerId'].sortType}} "></a></span>
            </th>
            <th scope="col">member id <span *ngIf="transactionListByClient.length" class="sort-order"
                (click)="sortColumn('memberId')"><a class="{{columnSort['memberId'].sortType}} "></a></span>
            </th>
            <th scope="col">ehealth id <span *ngIf="transactionListByClient.length" class="sort-order"
                (click)="sortColumn('eHealthId')"><a class="{{columnSort['eHealthId'].sortType}} "></a></span>
            </th>
            <th scope="col">facility id <span *ngIf="transactionListByClient.length" class="sort-order"
                (click)="sortColumn('documentID')"><a
                  class="{{columnSort['documentID'].sortType}} "></a></span>
            </th>
            <th scope="col">visit <span *ngIf="transactionListByClient.length" class="sort-order"
                (click)="sortColumn('visitedOn')"><a class="{{columnSort['visitedOn'].sortType}} "></a></span>
            </th>
            <th scope="col">Status</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>

        <tbody>

          <tr *ngFor="let item of transactionListByClient">
            <td>{{item.requestId | notEmpty}}</td>
            <td>{{item.senderId | notEmpty}}</td>
            <td>{{item.receiverId | notEmpty}}</td>
            <td>{{item.transactionDate | dateFormat | notEmpty}}</td>
            <td *ngIf="( subTypeEvm === subTypes.payer|| subTypeEvm === subTypes.both)">{{item.payerId | notEmpty}}</td>
            <td *ngIf="( subTypeEvm === subTypes.provider|| subTypeEvm === subTypes.both)">{{item.providerId | notEmpty}}</td>
            <td>{{item.memberId | notEmpty}}</td>
            <td>{{item.eHealthId | notEmpty}}</td>
            <td>{{item.faciltyId | notEmpty}}</td>
            <td>{{item.visitedOn | dateFormat | notEmpty}}</td>
            <td>
              <div class="status" *ngIf="item.approvalStatus===null"><span></span>- </div>
              <div class="status dark-red-circle-status" *ngIf="item.approvalStatus===0">
                <span></span>Rejected
              </div>
              <div class="status navy-blue-circle-status" *ngIf="item.approvalStatus===1">
                <span></span>Approved</div>
              <div class="status yellow-circle-status" *ngIf="item.approvalStatus===2">
                <span></span>Partially Approved </div>
                <div class="status red-circle-status" *ngIf="item.approvalStatus===3">
                  <span></span>Cancelled </div>
            </td>
            <td>
              <ul class="actions">
                <li *ngIf="checkPermission('getTransactionRequest')">
                  <a data-bs-toggle="modal" class="view tool-wrap position-relative"
                    (click)="showPrescriptionDetailsPopup(item)">
                    <div class="custom-tooltip tooltip-top" role="tooltip">
                      <div class="arrow"></div>
                      <div class="tooltip-inner"> View </div>
                    </div>
                  </a>
                </li>
                <li *ngIf="!checkPermission('getTransactionRequest')">-</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="inner-loader-wraper" *ngIf="fetchingInProgress">
        <div class="inner-loader"></div>
      </div>
      <div class="no-data with-border" *ngIf="!fetchingInProgress && !transactionListByClient.length">
        <img src="./assets/images/icons/no-data-img.svg" alt="">
        <p>No Results Found</p>
      </div>
    </div>

    <app-navigation *ngIf="!showNavigation" [listLength]="totalCount" [pageNo]="page_no"
      (currentPageDetail)="currentPageDetail($event)">
    </app-navigation>
  </div>
</div>